//区分站点不同字段埋点
let isSitesValue = {
  "app_country": "United States",
  "app_language": 'en-US',
  "site": "us",
  "store_time_zone":"America\/New_York",
   "platform": isMobile() ? 'wap': 'web',
}

// const allowedDomains = [
//   'be.funnyfuzzy.com',
//   'ch.funnyfuzzy.com',
//   'france.funnyfuzzy.com'
// ];
// const currentDomain = window.location.hostname;
// // 检查当前域名是否以允许的域名开头
// if (allowedDomains.some(domain => currentDomain === domain || currentDomain.startsWith(domain))) {
//   // 创建并添加consentmanager脚本
//   const script = document.createElement('script');
//   script.type = 'text/javascript';
//   script.dataset.cmpAb = '1';
//   script.src = 'https://cdn.consentmanager.net/delivery/autoblocking/5926b95791150.js';
//   script.dataset.cmpHost = 'a.delivery.consentmanager.net';
//   script.dataset.cmpCdn = 'cdn.consentmanager.net';
//   script.dataset.cmpCodesrc = '1';
//   document.head.appendChild(script);
  
//   // 添加meta标签
//   const meta = document.createElement('meta');
//   meta.name = 'google-site-verification';
//   meta.content = '7Qs9IENNNGSwrXPY-hWdZeiv3uqu9C80aMBbRWhqdXQ';
//   document.head.appendChild(meta);
// }

//以下为各个站点统一字段可复制粘贴，区分不同字段往上编写
//获取端口信息
const QUEUE_STORAGE_KEY = 'pending_analytics_events'; //持久化存储埋点数据
function getBrowserVersion() {
 const userAgent = navigator.userAgent;
  let osName = "Unknown OS";
  let osVersion = "Unknown Version";
  // Windows
  if (userAgent.indexOf("Windows NT") !== -1) {
    osName = "Windows";
    const match = userAgent.match(/Windows NT (\d+\.\d+)/);
    if (match) {
      osVersion = match[1];
      if (osVersion === "10.0") { osVersion = "10"; }
      else if (osVersion === "6.1") { osVersion = "7"; }
      else if (osVersion === "6.2") { osVersion = "8"; }
      else if (osVersion === "6.3") { osVersion = "8.1"; }
    }
  }
  // macOS
  else if (userAgent.indexOf("Macintosh; Intel Mac OS X") !== -1) {
    osName = "macOS";
    const match = userAgent.match(/Mac OS X (\d+_\d+_\d+)/);
    if (match) {
      osVersion = match[1].replace(/_/g, '.');
    }
  }
  // Linux 由于 Linux 并没有标准的版本号，需要特殊处理，可以根据分发版进行调整
  else if (userAgent.indexOf("Linux") !== -1) {
    osName = "Linux";
  }
  // iOS
  else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    osName = "iOS";
    const match = userAgent.match(/OS (\d+_\d+_\d+) like Mac OS X/);
    if (match) {
      osVersion = match[1].replace(/_/g, '.');
    }
  }
  // Android
  else if (userAgent.indexOf("Android") !== -1) {
    osName = "Android";
    const match = userAgent.match(/Android (\d+\.\d+(\.\d+)?)/);
    if (match) {
      osVersion = match[1];
    }
  }
  return { osName: osName,osVersion: osVersion };
}
//获取IP地址
async function getVisitorCountry() {
  try {
    let response = await fetch('https://app.funny-fuzzy.com/store/country')
    let resJson = await response.json();
    return resJson.data || {}
  } catch (error) {
    return {}
  }
}
//获取会话ID
function generateRandomId(length) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * charactersLength);
        result += characters[randomIndex];
    }
    firebaseSsionFunc({ "sessionid": result })
    return result
}
//埋点存储所有的页面会话记录
function firebaseSsionFunc(params,isValue) {
    let sessionObj = sessionStorage.getItem('firebaseSsionData') ? JSON.parse(sessionStorage.getItem('firebaseSsionData')) : {};
    let sessionResult = Object.assign(sessionObj,params) 
    sessionStorage.setItem('firebaseSsionData', JSON.stringify(sessionResult));
    if(isValue){ return sessionResult }
}
function isMobile() {
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
}
// 获取最新实时安全时间戳（整数毫秒）
function getSafeTimestamp() {
  const now = Date.now();
  if (now < 1577836800000) { // 2020-01-01 00:00:00 UTC
    const fallbackTime = (performance?.timeOrigin || Date.now()) + (performance?.now() || 0);
    return Math.round(fallbackTime);
  }
  return now;
}
//自定义埋点传值信息获取
async function firebaseParams(pageName,clickTimestamp = ''){
  let screenWidth = window.screen.width;  
  let screenHeight = window.screen.height;
  //获取流量段展示
  // if(!localStorage.getItem('trafficSegment')){
  //   let formData = { "storeId": "","client": "web", "deviceId": localStorage.getItem('device_uuid') }
  //   let response = await fetch(`https://app.funny-fuzzy.com/device/tag`,{
  //     method: 'POST',
  //     headers: { 'Content-Type': 'application/json' },
  //     body: JSON.stringify(formData)
  //   })
  //   const responseJson = await response.json();
  //   if(responseJson.code == 200){
  //      localStorage.setItem('trafficSegment',responseJson.data.tag)
  //   }
  // }
  //会话ID随机32位唯一数
  let storedSessionData = sessionStorage.getItem('firebaseSsionData');
  let ssionData = storedSessionData ? JSON.parse(storedSessionData) : {};
  
  if(!ssionData.osName){
    let browserVersion = getBrowserVersion();
    let version = { 'osName':browserVersion.osName, 'osVersion': browserVersion.osVersion }
    let getSessionData = firebaseSsionFunc(version,true)
    ssionData = Object.assign(getSessionData,version) 
  }
  
  //登录追踪ID获取
  // if(!ssionData.setCustomerCid && ssionData.isLogin){
  //   let UUID = uuidv4();
  //   localStorage.setItem('trace_id', UUID);
  //   firebaseSsionFunc({ 'isLogin': false })
  // }
  // if(ssionData.setCustomerCid){ firebaseSsionFunc({ 'isLogin': true }) }
  
  //域名链接获取，广告参数
  let href = window.location.href;
  if(href.indexOf('utm_campaign') != -1 || href.indexOf('dm_cam') != -1 || href.indexOf('tw_campaign') != -1){ 
    let urlObject = new URL(href);
    let paramsObject = Object.fromEntries(urlObject.searchParams.entries());
    let params = {
      "utm_source": paramsObject.utm_source || paramsObject.tw_source || paramsObject.dm_net || '',
      "utm_medium": paramsObject.utm_medium || paramsObject.dm_medium || paramsObject.tw_medium || '',
      "utm_campaign": paramsObject.utm_campaign || paramsObject.dm_cam || paramsObject.tw_campaign || '',
      "utm_term": paramsObject.utm_term || paramsObject.dm_grp || paramsObject.tw_term || '',
      "utm_content": paramsObject.utm_content || paramsObject.dm_ad || paramsObject.tw_adid || '',
    }
    let getSessionData = firebaseSsionFunc(params,true)
    ssionData = Object.assign(getSessionData,params) 
  }
  //第一次打开页面获取
  if(!ssionData.landing_page_url){
    let getSessionData = firebaseSsionFunc({ landing_page_url: href },true)
    ssionData = Object.assign(getSessionData,{ landing_page_url: href }) 
  }
  // 获取tid
  let tid = `${localStorage.getItem('device_uuid')}${getSafeTimestamp()}`;
  //语言获取
  let userLanguage = navigator.language || navigator.userLanguage;
  let firebaseObject = {
    "tid": tid,
    "last_tid": ssionData.last_tid || '', //上一个事件tid，如果同一个页面保持上一个事件tid，否则获取最新的上一个, 需要处理
    "user_id": ssionData.setCustomerCid ? `gid://shopify/Customer/${ssionData.setCustomerCid}` : '',
    "device_id": localStorage.getItem('device_uuid'),
    "session_id": ssionData.sessionid,
    // "trace_id": localStorage.getItem('trace_id'),
    // "device_brand": navigator.userAgent,
    // "device_model": navigator.userAgent,
    "device_os": ssionData.osName || '',
    "device_os_version": ssionData.osVersion || '',
    "device_resolution": `${screenWidth}/${screenHeight}`,
    "device_country": userLanguage.split('-')[1],
    "device_language": userLanguage,
    // "device_network_type": '',
    // "device_network_carrier": '',
    "device_ip": ssionData.ip || '',
    "ip_country": ssionData.country || '',
    "device_message_switch": '',
    // "device_fcm_token": '',
    "bird_push_token": '',
    
    "app_country": isSitesValue.app_country,
    "app_language": isSitesValue.app_language,
    "app_currency": ssionData.currency || '',
    "site": isSitesValue.site,
    "platform": isSitesValue.platform,
    "app_useragent": navigator.userAgent,
    "client_version": '1.0.3',
    "store_time_zone": isSitesValue.store_time_zone,
    "device_time_zone": Intl.DateTimeFormat().resolvedOptions().timeZone,
    
    // "adlink_id":"",
    // "madid":"",
    "utm_source": ssionData.utm_source || '',
    "utm_medium": ssionData.utm_medium || '',
    "utm_campaign": ssionData.utm_campaign || '',
    "utm_term": ssionData.utm_term || '',
    "utm_content": ssionData.utm_content || '',

    // "page_load_time": '', //页面完成加载时间，提交接口上传
    "landing_page_url": ssionData.landing_page_url,
    "url": href,
    "page_name": ssionData.pagesName,
    "url_path": href.split('//')[1],
    "last_url": document.referrer,
    "page_duration": ssionData.startTime,   //开始停留时间，接口提交时上报时间
    "page_deep": "1",  
    "reported_timestamp": '', //上报时间，接口提交时上报时间
    "event_timestamp": clickTimestamp || ssionData.startTime, //page事件进入页面时间，点击事件的传点击时间
    
    "page_position_id":"", //点击一个事件生成一个page_position_id
    "page_position_content": {},
    "last_page_position_id": ssionData.last_page_position_id || '', //上一个page_position_id传值
    "last_page_position_content": ssionData.last_page_position_content || {},
    "root_page_position_id": ssionData.root_page_position_id || '', //一级页面id，等待确定
    "root_page_position_content": ssionData.root_page_position_content || '',
    
    "event_name": pageName == 'page' ? `view_${ssionData.pagesName}` : 'add_to_cart',
    "track_type": pageName,
    "other_content":{},
  }
  sessionStorage.setItem('firebaseCustomerEvent', JSON.stringify([JSON.stringify(firebaseObject)]));
  if(pageName == 'page'){
     //购物车主页面
    if(ssionData.pagesName.indexOf('cart') != -1){
      let product = [];
      let page_position_content = ssionData.page_position_content || {};
      let productList = ssionData.page_position_content.items || [];
      let discount_code = '';
      let comparePriceElement = document.querySelectorAll('.line-item') || [];
      let comparePriceList = [];
      comparePriceElement.forEach((item,index)=>{
        let compare = item.querySelector('.line-item__price-list-container .price.price--compare') 
        let priceText = compare ? compare.textContent : '';
        let priceMatch = priceText.match(/(\d+\.\d{2})/);
        let price = priceMatch ? parseFloat(priceMatch[1]) : '';
        comparePriceList.push(price)
      })
      productList.forEach(async (item,index) => {
        let optionsObject = item.options_with_values.reduce((acc, option) => {
          acc[option.name] = option.value;
          return acc;
        }, {});
        if(!discount_code){
          discount_code = item.discounts.length != 0 ? item.discounts[0].title : '';
        }
        let items = {
          "product_specification": optionsObject,
          "product_id": item.product_id.toString(),
          "product_title": item.title,
          "product_img": item.image,
          "product_star": '',
          "sku_inventory": '',
          "quantity": item.quantity,
          "original_price": comparePriceList[index] ? ((comparePriceList[index]*100)/item.quantity)/100 : '',
          "price": item.price / 100,
        }
        product.push(items)
      })
      firebaseObject.page_position_content = {
        "cart_id": ssionData.token ? `gid://shopify/Cart/${ssionData.token}` : '',
        "product": product,
        "buddle_product": {},
        "product_quantity": page_position_content.item_count,
        "discount_code": discount_code,
        "subtotal_amount": page_position_content.original_total_price/100,
        "discount_amount": page_position_content.total_discount/100,
        "actual_amount": page_position_content.total_price/100,
      }
    }
    //产品详情页面
    if(ssionData.pagesName.indexOf('product_detail') != -1){
       firebaseObject.page_position_content = {
          "product_id": ssionData.page_position_content.id.toString(),
          "product_title": ssionData.page_position_content.title,
          "product_star": '',
          "product_inventory": '',
          "quantity": 1,
          "variant_id": ssionData.page_position_content.variant_id,
       }
       let variant = ssionData.page_position_content.variant_id;
       let variants = ssionData.page_position_content.variants;
       let options = ssionData.page_position_content.options || [];
       for(let i = 0; i < variants.length; i++){
          if(variants[i].id == variant){
            firebaseObject.page_position_content.original_price = (variants[i].compare_at_price/100).toString();
            firebaseObject.page_position_content.price = (variants[i].price/100).toString();
            firebaseObject.page_position_content.product_img = variants[i].featured_image && variants[i].featured_image.src;
            let product_specification = options.reduce((acc, name, index) => {
              acc[name] = variants[i].options[index];
              return acc;
            }, {});
            firebaseObject.page_position_content.product_specification = product_specification;
            break;
          }
       }
    }
    //系列列表
    if(ssionData.pagesName.indexOf('category_detail') != -1){
      firebaseObject.page_position_content = ssionData.page_position_content;
    }
    //搜索主页热搜词
    if(ssionData.pagesName.indexOf('search_result') != -1){
      const url = new URL(location.href);
      let q = url.searchParams.get("q");
      firebaseObject.page_position_content.keywords = q;
      firebaseObject.page_position_content.recent_search = [];
      firebaseObject.page_position_content.search_related_words = [];
      firebaseObject.page_position_content.success = 1;
    }
    firebaseObject.page_position_content.is_first_load = ssionData.is_first_load ? '1':'0';
  }
  // console.log('firebaseObject==============',firebaseObject)
  return firebaseObject
}
//节流
let _throttleRunning = false;
function throttle(fn, delay = 500) {
	if(_throttleRunning){ return; }
	_throttleRunning = true;
	fn();
	setTimeout(() => { _throttleRunning = false;}, delay);
}
// 防抖
let _debounceTimeout = null;
function debounce(fn, delay=500) {
    clearTimeout(_debounceTimeout);
	_debounceTimeout = setTimeout(() => { fn();}, delay);
}
let buriedEventQueue = [];
// page页面缓存事件+首次执行埋点代码
async function firebaseSoon(){
  //加载页面执行公共样式
  if(!localStorage.getItem('device_uuid')){
    let UUID = uuidv4();
    localStorage.setItem('device_uuid', UUID);
  }
  // if(!localStorage.getItem('trace_id')){
  //   let UUID = uuidv4();
  //   localStorage.setItem('trace_id', UUID);
  // }
  let storedSessionData = sessionStorage.getItem('firebaseSsionData');
  let ssionData = storedSessionData ? JSON.parse(storedSessionData) : {};
  let sessionid = ssionData.sessionid || '';
   if(!sessionid){ sessionid = generateRandomId(32); }
  //获取购物车ID,和赋值整个购物车
  let response = await fetch(`/cart/update.js`,{
    body: JSON.stringify({
        attributes: {
          "session_id": sessionid,
          "device_id": localStorage.getItem('device_uuid')
        }
    }),
    method: "POST",
    headers: {"Content-Type": "application/json"},
  });
  let responseJson = await response.json();
  firebaseSsionFunc({ "token": responseJson.token,  "currency": responseJson.currency })
  //获取网络IP
  if(!ssionData.ip){
    let ipInformation = await getVisitorCountry();
    let ipObecjt = { 'country':ipInformation.locationCountryName, 'ip':ipInformation.ip }
    firebaseSsionFunc(ipObecjt,true)
  }

  const saved = localStorage.getItem(QUEUE_STORAGE_KEY);
  if (saved) {
    buriedEventQueue = [...JSON.parse(saved), ...buriedEventQueue];
    // console.log('=====================数据剩余',JSON.parse(saved).length)
    localStorage.removeItem(QUEUE_STORAGE_KEY);
  }
  //page页面事件上传
  let firebaseParamsPage = await firebaseParams('page');
  pageApiRuequest(firebaseParamsPage)
}
firebaseSoon()
//page事件信息更改
async function pageApiRuequest(item){
  let storedSessionData = sessionStorage.getItem('firebaseSsionData');
  let ssionData = storedSessionData ? JSON.parse(storedSessionData) : {};
  let newDateTime = getSafeTimestamp();
  item.page_duration = newDateTime - item.page_duration; //停留时间
  // item.page_load_time = ssionData.page_load_time.toString() || "";
  if(ssionData.pagesName.indexOf('product') != -1){
    let stars = document.querySelector('.jdgm-prev-badge__stars');
    if(stars){
      let product_star = stars.getAttribute('data-score');
      item.page_position_content.product_star = product_star;
    }
  }
  firebaseSsionFunc({ 'last_tid': item.tid })
  item.reported_timestamp = newDateTime; //上报时间
  // console.log('============================page',item)
  buriedEventQueue.push(JSON.stringify(item))
  sendBatchToShopify()
}
//埋点页面加购点击事件
async function pageButtonEvent(product,quantity,variantId,page_position_id){
  let newDateTime = getSafeTimestamp();
  let firebaseObject = await firebaseParams('click',newDateTime);
  let productDetail = JSON.parse(product);
  let storedSessionData = sessionStorage.getItem('firebaseSsionData');
  let ssionData = storedSessionData ? JSON.parse(storedSessionData) : {};
  firebaseObject.page_position_content = {
      "cart_id": ssionData.token ? `gid://shopify/Cart/${ssionData.token}` : '',
      "product_id": productDetail.id.toString(),
      "product_title": productDetail.title,
      "product_star": '',
      "product_inventory": '',
      "quantity": quantity,
      "variant_id": variantId,
   }
  let variants = productDetail.variants;
  let options = productDetail.options || [];
  for(let i = 0; i < variants.length; i++){
      if(variants[i].id == variantId){
        firebaseObject.page_position_content.original_price = (variants[i].compare_at_price/100).toString();
        firebaseObject.page_position_content.price = (variants[i].price/100).toString();
        firebaseObject.page_position_content.product_img = variants[i].featured_image.src;
        let product_specification = options.reduce((acc, name, index) => {
          acc[name] = variants[i].options[index];
          return acc;
        }, {});
        firebaseObject.page_position_content.product_specification = product_specification;
        break;
      }
  }
  firebaseSsionFunc({ 'last_tid': firebaseObject.tid })
  firebaseObject.page_duration = newDateTime - firebaseObject.page_duration; //停留时间
  // firebaseObject.page_load_time = (ssionData.page_load_time).toString() || '';
  firebaseObject.reported_timestamp = newDateTime; //上报时间
  firebaseObject.page_position_content.is_first_load = ssionData.is_first_load ? '1' : '0';
  firebaseObject.page_position_id = page_position_id;
  // console.log('firebaseParamsArry===============',firebaseObject)
  buriedEventQueue.push(JSON.stringify(firebaseObject))
  sendBatchToShopify()
}
//页面事件点击和监听提交+曝光事件
async function watchEventSubmit(params = {}, eventName){
    let newDateTime = getSafeTimestamp();
    let firebaseObject = await firebaseParams('click',newDateTime);
    let storedSessionData = sessionStorage.getItem('firebaseSsionData');
    let ssionData = storedSessionData ? JSON.parse(storedSessionData) : {};
    firebaseObject.page_duration = newDateTime - firebaseObject.page_duration; //停留时间
    // firebaseObject.page_load_time = (ssionData.page_load_time).toString() || '';
    firebaseObject.reported_timestamp = newDateTime; //上报时间
    firebaseObject.event_name = params.eventName || eventName;
    if(params.eventType){ firebaseObject.track_type = params.eventType }
    firebaseObject.page_position_id = params.page_position_id;
    firebaseObject.page_position_content = params.page_position_content;
    let ssionSet = { 'last_tid': firebaseObject.tid }
    // console.log('ssionSet=====================',firebaseObject.track_type == 'click' , params.isUrl)
    if(firebaseObject.track_type == 'click' && params.isUrl){
      ssionSet.last_page_position_id = firebaseObject.page_position_id;
      ssionSet.last_page_position_content = firebaseObject.page_position_content;
      if(ssionData.pagesName == 'home'){
        ssionSet.root_page_position_id = firebaseObject.page_position_id;
        ssionSet.root_page_position_content = firebaseObject.page_position_content;
      }
    }
    firebaseSsionFunc(ssionSet)
    if(eventName == 'search_result'){
      firebaseObject.page_position_content = {
        "keywords": params.keywords || '',
        "recent_search":[],
        "search_related_words":[],
        "success": params.success
      }
    }else if(eventName == 'subscribe'){
      firebaseObject.page_position_content = { "email": params.email || '' }
    }
    firebaseObject.page_position_content.is_first_load = ssionData.is_first_load ? '1' : '0';
    // console.log(params.ex_index,'========================params',firebaseObject)
    // window.onbeforeunload = function(e) {
    //   return "确定离开当前页面？查看完日志后再跳转！";
    // };
    buriedEventQueue.push(JSON.stringify(firebaseObject));
    if(buriedEventQueue.length < 10){
      debounce(async ()=>{ sendBatchToShopify() },50)
    }else{
      throttle(async ()=>{ sendBatchToShopify() },5000)
    }
}
//批量处理转接代码
function sendBatch() {
  if (buriedEventQueue.length > 0) {
    // console.log('=====================数据存储',buriedEventQueue.length)
    localStorage.setItem(QUEUE_STORAGE_KEY, JSON.stringify(buriedEventQueue));
  }
}
// 页面关闭前发送
window.addEventListener('beforeunload', sendBatch);
window.addEventListener('pagehide', sendBatch);
// 当前活跃的AbortController（用于终止请求）
let activeAbortController = null;
async function sendBatchToShopify() {
  // console.log('=====================数据执行',buriedEventQueue.length)
  if (sendBatchToShopify.isProcessing || buriedEventQueue.length === 0) return;
  sendBatchToShopify.isProcessing = true;
  const BATCH_SIZE = 10;
  const REQUEST_DELAY = 500;
  const ERROR_RETRY_DELAY = 2000;
  try {
    while (buriedEventQueue.length > 0) {
      const batch = buriedEventQueue.splice(0, Math.min(BATCH_SIZE, buriedEventQueue.length));
      try {
        await allApiRuequest(batch);
        if (buriedEventQueue.length > 0) {
          await new Promise(resolve => setTimeout(resolve, REQUEST_DELAY));
        }
      } catch (error) {
        buriedEventQueue.unshift(...batch);
        await new Promise(resolve => setTimeout(resolve, ERROR_RETRY_DELAY));
        // continue;
      }
    }
  } finally {
    // 无论成功或失败，最终都标记处理结束
    sendBatchToShopify.isProcessing = false;
  }
}

//所有埋点接口请求API处
async function allApiRuequest(params) {
  const response = await fetch('https://app.funny-fuzzy.com/record', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({client: "web",type: "event",content: params }),
    keepalive: true
  });
  if (!response.ok) {
    const error = new Error(`HTTP错误! 状态码: ${response.status}`);
    error.statusCode = response.status;
    throw error;
  }
  // console.log('====================已经请求数据量',params.length)
}
//APP下载点击埋点链接
function downloadapplink(event_name){
  //app下载头部弹窗 snippets/app-download.liquid
  if(event_name == 1){  event_name = "click-diversion_web_to_app_top_bar-default" }
  throttle(async ()=>{
      let newDateTime = getSafeTimestamp();
      let firebaseObject = await firebaseParams('click',newDateTime);
      let storedSessionData = sessionStorage.getItem('firebaseSsionData');
      let ssionData = storedSessionData ? JSON.parse(storedSessionData) : {};
      firebaseSsionFunc({ 'last_tid': firebaseObject.tid })
      firebaseObject.page_duration = newDateTime - firebaseObject.page_duration; //停留时间
      // firebaseObject.page_load_time = (ssionData.page_load_time).toString() || '';
      firebaseObject.reported_timestamp = newDateTime; //上报时间
      firebaseObject.event_name = event_name;
      firebaseObject.page_position_content.is_first_load = ssionData.is_first_load ? '1' : '0';
      let web_landing_page_1 = window.location.href;
      let contentHref = `https://funnyfuzzy.go.link?type=1&adj_t=1nynj6nz&adj_label=&utm_source=web_to_app&utm_campaign=shopify_web&utm_medium=web_to_app&adj_engagement_type=fallback_click&adj_deep_link=funnyfuzzy%3A%2F%2F`;
      if(event_name == 'click-diversion_web_to_app_center_overlay_popup-default'){
        contentHref = `https://funnyfuzzy.go.link?type=1&adj_t=1n24i21t&adj_label=&utm_source=web_to_app&utm_campaign=popup&utm_medium=web_to_app&adj_engagement_type=fallback_click&adj_deep_link=funnyfuzzy%3A%2F%2F`
      }
      // console.log(decodeURIComponent(`${contentHref}&tid=${firebaseObject.tid}&web_landing_page=${web_landing_page_1}`))
      // return false 
      // window.open('https://www.baidu.com', '_blank');
      // await allApiRuequest(firebaseObject)
      buriedEventQueue.push(JSON.stringify(firebaseObject))
      sendBatchToShopify()
      window.location.href = `${contentHref}&tid=${firebaseObject.tid}&web_landing_page=${web_landing_page_1}`;
  },2000)
}
//模块预览曝光事件
function downloadappshowDiv(editobj = {}){
  throttle(async ()=>{
      let newDateTime = getSafeTimestamp();
      let firebaseObject = await firebaseParams('click',newDateTime);
      let storedSessionData = sessionStorage.getItem('firebaseSsionData');
      let ssionData = storedSessionData ? JSON.parse(storedSessionData) : {};
      firebaseSsionFunc({ 'last_tid': firebaseObject.tid })
      firebaseObject.page_duration = newDateTime - firebaseObject.page_duration; //停留时间
      // firebaseObject.page_load_time = (ssionData.page_load_time).toString() || '';
      firebaseObject.reported_timestamp = newDateTime; //上报时间
      firebaseObject = Object.assign(firebaseObject,editobj)
      firebaseObject.page_position_content.is_first_load = ssionData.is_first_load ? '1' : '0';
      buriedEventQueue.push(JSON.stringify(firebaseObject))
      sendBatchToShopify()
  },2000)
}
//shopify商品数据过滤出第一个变体信息
function filterCartProduct(list,variantId = ''){
  if(!variantId){ variantId = list.variants[0].id; }
  let productInformation = {
      "product_id": list.id.toString(),
      "product_title": list.title,
      "product_star": '',
      "product_inventory": '',
      "quantity": 1,
      "variant_id": variantId,
   }
   let variants = list.variants;
   let options = list.options || [];
   for(let i = 0; i < variants.length; i++){
      if(variants[i].id == variantId){
        // console.log('========================',variants[i])
        productInformation.original_price = (variants[i].compare_at_price/100).toString();
        productInformation.price = (variants[i].price/100).toString();
        productInformation.product_img = variants[i].featured_image?.src;
        let product_specification = options.reduce((acc, name, index) => {
          acc[name] = variants[i].options[index];
          return acc;
        }, {});
        productInformation.product_specification = product_specification;
        break;
      }
  }
  return productInformation
}